/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GMWIds } from "./GMWIds";
import { GMWIdsFromJSON, GMWIdsFromJSONTyped, GMWIdsToJSON, GMWIdsToJSONTyped } from "./GMWIds";

/**
 *
 * @export
 * @interface ApiGmwIdsList200Response
 */
export interface ApiGmwIdsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGmwIdsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGmwIdsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmwIdsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GMWIds>}
   * @memberof ApiGmwIdsList200Response
   */
  results: Array<GMWIds>;
}

/**
 * Check if a given object implements the ApiGmwIdsList200Response interface.
 */
export function instanceOfApiGmwIdsList200Response(
  value: object
): value is ApiGmwIdsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGmwIdsList200ResponseFromJSON(json: any): ApiGmwIdsList200Response {
  return ApiGmwIdsList200ResponseFromJSONTyped(json, false);
}

export function ApiGmwIdsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmwIdsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GMWIdsFromJSON),
  };
}

export function ApiGmwIdsList200ResponseToJSON(json: any): ApiGmwIdsList200Response {
  return ApiGmwIdsList200ResponseToJSONTyped(json, false);
}

export function ApiGmwIdsList200ResponseToJSONTyped(
  value?: ApiGmwIdsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GMWIdsToJSON),
  };
}
